import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'myrtls-site',
    templateUrl: './site.component.html',
    styleUrls: ['./site.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class SiteComponent {}
